import React from 'react';
import { TableRow } from '@mui/material';
export default function Row(_a) {
    var children = _a.children;
    return (React.createElement(TableRow, null, children));
}
